/**
 * 腾讯云 SDKAppId，需要替换为您自己账号下的 SDKAppId。
 *
 * 进入腾讯云实时音视频[控制台](https://console.cloud.tencent.com/rav ) 创建应用，即可看到 SDKAppId，
 * 它是腾讯云用于区分客户的唯一标识。
 */
const SDKAPPID = 20004041;

/**
 * 签名过期时间，建议不要设置的过短
 * <p>
 * 时间单位：秒
 * 默认时间：7 x 24 x 60 x 60 = 604800 = 7 天
 */
const EXPIRETIME = 604800;

/**
 * 计算签名用的加密密钥，获取步骤如下：
 *
 * step1. 进入腾讯云实时音视频[控制台](https://console.cloud.tencent.com/rav )，如果还没有应用就创建一个，
 * step2. 单击“应用配置”进入基础配置页面，并进一步找到“帐号体系集成”部分。
 * step3. 点击“查看密钥”按钮，就可以看到计算 UserSig 使用的加密的密钥了，请将其拷贝并复制到如下的变量中
 *
 * 注意：该方案仅适用于调试Demo，正式上线前请将 UserSig 计算代码和密钥迁移到您的后台服务器上，以避免加密密钥泄露导致的流量盗用。
 * 文档：https://cloud.tencent.com/document/product/647/17275#Server
 */
const SECRETKEY = 'e6db245325c2a8904a95bb126f9fc630d14e2143660c2c3ecc75df9c3059512f';

const AUDIENCE = 'audience';
const ANCHOR = 'anchor';

export { SDKAPPID, EXPIRETIME, SECRETKEY, AUDIENCE, ANCHOR };

import LibGenerateTestUserSig from './lib-generate-test-usersig-es.min';
import { setCredentials } from '../redux/reducer/userProfile';

// a soft reminder to guide developer to configure sdkAppId/secretKey
if (SDKAPPID === '' || SECRETKEY === '') {
    alert('请先配置好您的账号信息： SDKAPPID 及 SECRETKEY '
        + '\r\n\r\nPlease configure your SDKAPPID/SECRETKEY in src/app/config.js');
}

const generator = new LibGenerateTestUserSig(SDKAPPID, SECRETKEY, EXPIRETIME);

/**
 * 获取 userSig 和 privateMapKey
 * @param {string} userID 用户名
 */
export async function getLatestUserSig(userID) {
  const userSig = generator.genTestUserSig(userID);

  return {
      userSig,
      privateMapKey: 255,
  };
}
